import { ErrorDisplay } from "@/components/base";
import { Box, Button } from "@mui/material";
import { type ErrorComponentProps, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function ErrorPage({ error, info, reset }: ErrorComponentProps) {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<ErrorDisplay error={error} info={info}>
			<Box sx={{ display: "flex", gap: "1rem" }}>
				<Button title="Try again" onClick={reset} />
				<Button
					title={t("auth.gohome")}
					onClick={() => navigate({ to: "/" })}
				/>
			</Box>
		</ErrorDisplay>
	);
}
